'use client'

import { useEffect } from 'react'

import { setPageContext } from '@/utilities/analytics'

type Props = {
  pageType?: string | null
  cmsCollection: 'pages' | 'products' | 'projects' | 'jobs' | 'aktuell'
  productCategory?: string | null
  jobDepartment?: string | null
}

/**
 * Side-effect-only client component. Renders nothing. Pushes per-page
 * dimensions (page_type, cms_collection, product_category, job_department)
 * to gtag so all subsequent interaction events on this page carry them.
 *
 * Drop it at the top of each route's page.tsx. Re-mounts on route change,
 * which re-sets the context — exactly what we want for SPA navigations.
 */
export default function AnalyticsPageContext({
  pageType,
  cmsCollection,
  productCategory,
  jobDepartment,
}: Props) {
  useEffect(() => {
    setPageContext({
      page_type: pageType ?? 'standard',
      cms_collection: cmsCollection,
      product_category: productCategory ?? undefined,
      job_department: jobDepartment ?? undefined,
    })
  }, [pageType, cmsCollection, productCategory, jobDepartment])

  return null
}
